module.exports = __webpack_public_path__ + "img/avatar-png-1.e67e358c.png";